import { create } from 'zustand'
import { projectsApi } from '../lib/projectsApi'

export const useProjectsStore = create((set, get) => ({
  projects: [],
  currentPage: 1,
  perPage: 50,
  totalCount: 0,
  totalPages: 0,
  hasNext: false,
  hasPrevious: false,
  isLoading: false,
  error: null,

  /**
   * Fetch projects for a specific page
   */
  fetchProjects: async (page = 1, perPage = 50) => {
    set({ isLoading: true, error: null })
    try {
      const response = await projectsApi.fetchProjects(page, perPage)
      
      if (response.success) {
        set({
          projects: response.data || [],
          currentPage: response.pagination.page,
          perPage: response.pagination.per_page,
          totalCount: response.pagination.total_count,
          totalPages: response.pagination.total_pages,
          hasNext: response.pagination.has_next,
          hasPrevious: response.pagination.has_previous,
          isLoading: false,
          error: null,
        })
        return { success: true, data: response.data }
      } else {
        throw new Error(response.message || 'Failed to fetch projects')
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message || 'Failed to fetch projects'
      set({ 
        error: errorMessage, 
        isLoading: false,
        projects: [],
      })
      return { success: false, error: errorMessage }
    }
  },

  /**
   * Go to next page
   */
  nextPage: async () => {
    const { currentPage, totalPages, perPage } = get()
    if (currentPage < totalPages) {
      await get().fetchProjects(currentPage + 1, perPage)
    }
  },

  /**
   * Go to previous page
   */
  previousPage: async () => {
    const { currentPage, perPage } = get()
    if (currentPage > 1) {
      await get().fetchProjects(currentPage - 1, perPage)
    }
  },

  /**
   * Go to specific page
   */
  goToPage: async (page) => {
    const { perPage } = get()
    if (page >= 1) {
      await get().fetchProjects(page, perPage)
    }
  },

  /**
   * Clear projects
   */
  clearProjects: () => {
    set({
      projects: [],
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false,
      error: null,
    })
  },

  /**
   * Clear error
   */
  clearError: () => {
    set({ error: null })
  },
}))
